import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { environment } from '@env/environment'
import { AppModule } from './app/app.module'
import * as Sentry from '@sentry/angular'

Sentry.init({
    dsn: environment.sentryDsn,
    integrations: [
        // Registers and configures the Tracing integration,
        // which automatically instruments your application to monitor its
        // performance, including custom Angular routing instrumentation
        Sentry.browserTracingIntegration(),
        // Registers the Replay integration,
        // which automatically captures Session Replays
        Sentry.replayIntegration(),
        Sentry.captureConsoleIntegration({ levels: ['error'] }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: environment.sentryTracesSampleRate,
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: environment.sentryTracePropagationTargets,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: environment.sentryReplaysSessionSampleRate,
    replaysOnErrorSampleRate: environment.sentryReplaysOnErrorSampleRate,
    release: environment.applicationVersion,
    environment: environment.sentryEnv,
})

if (environment.production) {
    enableProdMode()
}

platformBrowserDynamic().bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
})
